import { gap, media, spacing } from '@lamimed/pantheon';
import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  ${gap(spacing.medium)};

  ${media.greaterThan('tablet')`
    text-align: center;
  `};
`;
